import $ from 'jquery';
import throttle from 'lodash/throttle.js';
import {deviceIsMinMd} from '../../js/utilities/media-queries.mjs';

const namespace = '.TeaserEditorialLine';
const cssClassExpandEnabled = '-expand-enabled';
const cssClassLineClamp = '-line-clamp';

class TeaserEditorialLine {
  constructor($teaser) {
      this.$teaser = $teaser;
      this.$contentWrapper = $teaser.find('.ef-editorial-teaser-line__info');
      this.$content = $teaser.find('.ef-editorial-teaser-line__rte-content');
      this.$button = $teaser.find('.ef-button-collapse');

      addTextExpand.call(this);
      $(window).on('resize', throttle(() => {
        removeTextExpand.call(this);
        addTextExpand.call(this);
      }, 1000));
  }
}

export function initTeaserEditorialLineTextExpand() {
  const $teaser = $('.ef-editorial-teaser-line');

  $teaser.each((index, teaser) => {
    new TeaserEditorialLine($(teaser))
  });
}

function addTextExpand() {
  const contentHeight = this.$content[0].clientHeight;
  const contentExtendedHeight = this.$content[0].scrollHeight;
  const textIsNotExpandable = contentExtendedHeight <= contentHeight;

  if (textIsNotExpandable) {
    // Do nothing
    return;
  }

  // Enable line-clamp after the calculation, since it influence the max-height
  this.$content.addClass(cssClassLineClamp);

  this.$button.on('click' + namespace, () => {
    if (this.$content.hasClass('-disabled') === false) {
      // Expand
      const contentWrapperOffsetTop = this.$contentWrapper.position().top;

      if (deviceIsMinMd.matches) {
        this.$teaser.css({
          alignItems: 'flex-start',
        });

        this.$contentWrapper.css({
          marginTop: contentWrapperOffsetTop,
        });
      }

      this.$content.addClass('-disabled').css({
        maxHeight: contentExtendedHeight,
      });

      this.$button.removeClass('collapsed');
    } else {
      // Collapse
      this.$content.attr('style', '');

      this.$button.addClass('collapsed');

      setTimeout(() => {
        this.$content.removeClass('-disabled');

        this.$teaser.css({
          alignItems: '',
        });

        this.$contentWrapper.css({
          marginTop: 0,
        });
      }, 300);
    }
  });
  this.$teaser.addClass(cssClassExpandEnabled);
}

function removeTextExpand() {
  this.$teaser.removeClass(cssClassExpandEnabled);
  this.$content.removeClass(cssClassLineClamp);
  this.$button.off('click' + namespace);
}
